import { render, staticRenderFns } from "./ComplaintSectors.vue?vue&type=template&id=3c8e186c&"
import script from "./ComplaintSectors.vue?vue&type=script&lang=js&"
export * from "./ComplaintSectors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports